export default "__VITE_ASSET__PVDZXFXa__"